import React from 'react'
import styled, { css, keyframes } from 'styled-components'

const ShakeShake = keyframes`
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-6px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(6px, 0, 0);
  }
`

const Button = styled.button`
  padding: 0 40px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-radius: 29px;
  background-color: #2e5f62;
  color: #ffffff;
  border: 0;
  font-size: 16px;
  margin-top: 30px;
  cursor:  ${props => props.disabled === true ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled === true ? 0.5 : 1};

  ${props => props.styleType === 'secondary' && css`
    background: transparent;
    border: 2px solid #2e5f62;
    color: #2e5f62;
    `
  }

  ${props => props.error && css`
    animation-name: ${ShakeShake};
    animation-duration: 1s;
    animation-iteration-count: 4;
    animation-timing-function: cubic-bezier(.36,.07,.19,.97);
    `
}
`

const CtaBtn = (props) => {
  const { children, handleClick, isLoading, error, styleType, disabled } = props
  return (
    <Button
      type='submit'
      disabled={isLoading || disabled}
      onClick={handleClick}
      error={error}
      styleType={styleType}
    >
      {isLoading ? 'Loading...' : children}
    </Button>
  )
}

export default CtaBtn
